<template>
    <div>
        <div class="row my-3 mx-2">
          <h1 >{{$t('add_new_clinic_service')}}</h1>
          <div class="col-auto ml-auto mr-4 doctors-nav-link pt-2">
            <router-link
            :to="`/cadmin/doctors`"
            >
              ექიმები ->
            </router-link>
          </div>
        </div>

        <div class="border round py-5 px-3 mb-5 new-service-block">
        <div class="my-3 row px-3">
               <div class="col-4">
                  <my-select
                    :options.sync="servicesStatic"
                    placeholder="მაგ. კონსულტაცია ფსიქოლოგთან"
                    :multiple="false"
                    loadingText="იტვირთება"
                    noOptionsText="დაიწყეთ აკრეფა"
                    :on-change="setCSService"
                    :only-ka="false"
                  >
                  </my-select>
              </div>
               <div class="col-4">
                  <my-select
                    :options.sync="clinic_serviceTypes"
                    placeholder="მაგ. ონლაინ, გამოძახება"
                    :multiple="false"
                    noOptionsText="დაიწყეთ აკრეფა"
                    :on-change="setCSServiceType"
                    :only-ka="true"
                  >
                  </my-select>
              </div>
              <div class="col-4 myfield" style="margin-top:-33px;">
                    <input
                      type="number"
                      id="cs_price"
                      v-model="cs_price"
                      style=""
                      :placeholder="$t('cs_price')"
                    />
                     <label for="cs_price">{{ $t("cs_price") }}</label>
              </div>
        </div>
        <div class="my-5 row px-3">
            <div class="col-4 myfield" style="margin-top:-33px;">
                    <input
                      type="number"
                      id="cs_duration"
                      v-model="cs_duration"
                      style=""
                      :placeholder="$t('cs_duration')"
                    />
                     <label for="cs_duration">{{ $t("cs_duration") }}</label>
            </div>
            <div class="col-4 myfield" style="margin-top:-33px;">
                    <input
                      type="number"
                      id="cs_communication_days"
                      v-model="cs_communication_days"
                      style=""
                      :placeholder="$t('cs_communication_days')"
                    />
                     <label for="cs_communication_days">{{ $t("cs_communication_days") }}</label>
            </div>
            <div class="col-4">
                    <my-select
                    :options.sync="interviewTypes"
                    placeholder="წინასწარი გამოკითხვა"
                    :multiple="false"
                    noOptionsText="დაიწყეთ აკრეფა"
                    :on-change="setCSInterviewType"
                    :only-ka="true"
                  >
                  </my-select>
            </div>
        </div>
        <div class="mt-5 row px-3">
            <button
                  class="btn btn-outline-primary btn-block"
                  @click.prevent="createclinic_service"
                >
                  {{ $t('save') }}
                </button>
            </div>
        </div>

        <h1 class="my-5 mx-2">{{$t('clinic_services')}}</h1>
        <div v-if="services.length !=0">
            <div v-for="service in services" v-bind:key="service.id">
                <div class="row no-gutters align-items-center p-3 border rounded">
                    <div class="col-4 mr-2">
                        <strong>{{service.name[authLocale]}}</strong>
                    </div>
                    <div class="col">
                        <div v-if="service.clinic_services.length!=0">
                            <div class="p-3" v-for="cs in service.clinic_services" v-bind:key="cs.id">
                                <div class="mb-3 row">
                                    <div class="pt-2"><strong>{{typeName(cs.type)}} - {{(cs.price / 100).toFixed(2)}} ₾</strong></div>
                                    <div v-if="!cs.is_personal" class="non-personalized-text ml-3 pt-2">
                                        ({{$t('non_personalized_service')}})
                                    </div>
                                    <div class="ml-3" v-if="!cs.is_personal || (cs.is_personal&&cs.asignees==0)">
                                        <button
                                          class="btn btn-outline-danger btn-block"
                                          @click.prevent="removeclinic_service(cs.id)"
                                        >
                                           {{$t('remove_clinic_service')}}
                                        </button>
                                    </div>
                                </div>
                                <div v-if="service.is_personal" class=" pl-4">
                                   <div class="row pt-3 pb-5">
                                    <div class="col-6">
                                        <my-select
                                          :options.sync="doctorsStatic"
                                          placeholder="სახელი/პირადი ნომერი"
                                          :multiple="false"
                                          loadingText="იტვირთება"
                                          noOptionsText="დაიწყეთ აკრეფა"
                                          :on-change="setNewAssigneeParam"
                                          :only-ka="false"
                                        >
                                        </my-select>
                                    </div>
                                    <div class="col">
                                        <button
                                          class="btn btn-outline-primary btn-block"
                                          @click.prevent="createNewAssignee(cs)"
                                        >
                                          {{ $t('save') }}
                                        </button>
                                    </div>
                                    </div>

                                    <div v-if="cs.asignees.length!=0">
                                        <div v-for="csa in cs.asignees" v-bind:key="csa.id" class="row align-items-center p-3 border rounded assignee-block">
                                                <div class="col-auto mr-2">
                                                  <div
                                                    class="avatar"
                                                    :style="{
                                                      backgroundImage: `url(${staticUrl}${csa.photo})`,
                                                    }"
                                                  ></div>
                                                </div>
                                                <div class="col-auto">
                                                  <strong>
                                                    {{ csa.firstname[authLocale] }}
                                                    {{ csa.lastname[authLocale] }}
                                                  </strong>
                                                </div>
                                                <div class="col-auto ml-auto">
                                                    <button
                                                      class="btn btn-outline-danger btn-block close-btn"
                                                      @click.prevent="removeAssignee(csa.id,cs.id)"
                                                    >
                                                       <close class="close-icon"></close>
                                                    </button>
                                                </div>
                                        </div>
                                    </div>
                                    <div v-else>* {{$t('no_assignee')}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <strong>* {{$t('no_clinic_services')}}</strong>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div v-else>
            <h4>{{$t('no_services_found')}}</h4>
        </div>
    </div>
</template>
<script>
import MySelect from '@/components/SymptomChecker/MySelect'
import Close from '@/components/Icons/Close.vue'
import Fetch from '@/mixins/Fetch'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: { MySelect, Close },
  mixins: [Fetch],
  data () {
    return {
      cs_price: 0,
      cs_duration: 0,
      cs_communication_days: 0,
      cs_service_id: null,
      cs_service_type: null,
      cs_interview_type: null,
      newassignee_id: null,
      services: [],
      servicesStatic: [],
      doctorsStatic: [],
      clinic_serviceTypes: [{ id: 'telemedicine', label: 'ონლაინ' }, { id: 'visit', label: 'კლინიკაში' }, { id: 'house_call', label: 'გამოძახება' }],
      interviewTypes: [{ id: 'SymptomChecker', label: 'სიმპტომ ჩეკერი' }]
    }
  },
  mounted () {
    this.fetchServices()
    this.fetchServicesStatic()
    this.fetchDoctorsStatic()
  },
  computed: {

    ...mapGetters({
      authLocale: 'auth/locale',
      staticUrl: 'app/staticUrl'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setAlert: 'alert/setAlert'
    }),
    setNewAssigneeParam (val) {
      if (!val) {
        this.newassignee_id = null
      }
      this.newassignee_id = val.id
    },
    async createNewAssignee (cs) {
      if (!this.newassignee_id) {
        return
      }
      const params = {
        doctor_id: this.newassignee_id,
        clinic_service_id: cs.id
      }
      try {
        await this.axios.post('/admin/assignees', params).then(result => {
          if (result.data && result.data.data) {
            this.fetchServices()
          }
          this.setNewAssigneeParam(null)
          this.setAlert({
            message: 'ექიმი წარმატებით დაფიქსირდა შემსრულებლად',
            type: 'info'
          })
        })
      } catch (err) {
        this.setError(err)
      }
    },
    async createclinic_service () {
      const params = {
        price: parseInt(this.cs_price),
        duration: parseInt(this.cs_duration),
        communication_days: parseInt(this.cs_communication_days),
        service_id: this.cs_service_id,
        type: this.cs_service_type,
        interview_type: this.cs_interview_type
      }
      try {
        await this.axios.post('/admin/clinic-services', params).then(result => {
          if (result.data && result.data.data) {
            this.fetchServices()
          }
          this.clearForm()
          this.setAlert({
            message: 'კლინიკის სერვისი წარმატებით შეიქმნა',
            type: 'info'
          })
        })
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchServices () {
      try {
        const response = await this.axios.get('/admin/services')
        if (response.data && response.data.data) {
          this.services = response.data.data
        }
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchServicesStatic () {
      try {
        const response = await this.axios.get('/api/static/services')
        if (response.data && response.data.data) {
          response.data.data.forEach(s => {
            this.servicesStatic.push({ id: s.id, label: s.name[this.authLocale] })
          })
        }
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchDoctorsStatic () {
      try {
        const response = await this.axios.get('/admin/doctors/short')
        if (response.data && response.data.data) {
          response.data.data.forEach(d => {
            this.doctorsStatic.push({ id: d.id, label: d.fullname })
          })
        }
      } catch (err) {
        this.setError(err)
      }
    },
    typeName (csType) {
      switch (csType) {
        case 'telemedicine':
          return this.$t('telemedicine')
        case 'visit':
          return this.$t('visit')
        case 'house_call':
          return this.$t('house_call')
        default:
          return 'X'
      }
    },
    setCSService (val) {
      if (!val) {
        this.cs_service_id = null
        return
      }
      this.cs_service_id = val.id
    },
    setCSServiceType (val) {
      if (!val) {
        this.cs_service_type = null
        return
      }
      this.cs_service_type = val.id
    },
    setCSInterviewType (val) {
      if (!val) {
        this.cs_interview_type = null
        return
      }
      this.cs_interview_type = val.id
    },
    clearForm () {
      this.cs_price = null
      this.cs_duration = null
      this.cs_communication_days = null
    //   this.cs_service_id = null
    //   this.cs_service_type = null
    //   this.cs_interview_type = null
    },
    async removeclinic_service (csID) {
      try {
        await this.axios.delete('/admin/clinic-services/' + csID).then(() => {
          this.fetchServices()
          this.setAlert({
            message: 'კლინიკის სერვისი წარმატებით წაიშალა',
            type: 'info'
          })
        })
      } catch (err) {
        this.setError(err)
      }
    },
    async removeAssignee (csaID, csID) {
      const params = {
        doctor_id: csaID,
        clinic_service_id: csID
      }
      try {
        await this.axios.delete('/admin/assignees', { data: params }).then(result => {
          this.fetchServices()
          this.setAlert({
            message: 'ექიმი წარმატებით წაიშალა',
            type: 'info'
          })
        })
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style scoped>
.non-personalized-text{
    font-size:0.7em;
}
.assignee-block{
    width: 70%;
}
.new-service-block{
    width:70%;
    margin-left:15%;
}
.close-btn {
    width:50px;
}
.close-icon {
        width: 24px;
        height: 24px;
        position: absolute;
        cursor: pointer;
}
.doctors-nav-link{
  font-size:1.2em;
}
</style>
<i18n>
{
  "ka": {
      "no_services_found": "არცერთი სერვისი არ მოიძებნა",
      "no_clinic_services": "არცერთი კლიინიკის სერვისი არ არის მიმაგრებული",
      "no_assignee": "არცერთი ექიმი არ არის მიმაგრებული",
      "telemedicine": "ონლაინ",
      "visit": "კლინიკაში",
      "house_call": "გამოძახება",
      "remove_assignee": "ექიმის წაშლა",
      "non_personalized_service": "არაპერსონალიზებული სერვისი",
      "delete_assignee":"შემსრულებლის წაშლა",
      "cs_price":"ღირებულება (თეთრებში)",
      "cs_duration":"ხანგრძლივობა (წუთებში)",
      "cs_communication_days":"კომუნიკაციის დღეები",
      "clinic_services":"კლინიკის სერვისები",
      "add_new_clinic_service":"ახალი სერვისის დამატება",
      "save":"შენახვა",
      "remove_clinic_service":"სერვისის წაშლა"
  }
}
</i18n>
